/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingHolidayDelivery_item = {
    readonly shipmentDeliveryEstimations: ReadonlyArray<{
        readonly shipmentQuoteId: string | null;
        readonly maxDaysToDeliver: number | null;
    } | null> | null;
    readonly " $refType": "PdpSharedShippingHolidayDelivery_item";
};
export type PdpSharedShippingHolidayDelivery_item$data = PdpSharedShippingHolidayDelivery_item;
export type PdpSharedShippingHolidayDelivery_item$key = {
    readonly " $data"?: PdpSharedShippingHolidayDelivery_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingHolidayDelivery_item">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedShippingHolidayDelivery_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "shipmentDeliveryEstimations",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentDeliveryEstimationsType",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "shipmentQuoteId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "maxDaysToDeliver",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '269c5cd017162b85c25f1afcc45b1822';
export default node;
